import { ASSETS_LIST_NUM } from '@nile/rmm/src/constants';

const CHAT_TIMER_INSEC = 2 * 60;

const IS_CHAT_ROUTE = window?.location?.hash?.includes('#/systray/chat');
const IS_SYSTEMTRAY_ROUTE = window?.location?.hash?.includes('#/systray/');

const SOURCE = {
  WEB: 'web',
  AGENT: 'agent'
};

const SUBPAGE = {
  TICKET: 'Ticket',
  ASSET: 'Asset',
  ALERT: 'Alert'
};

const EVENT = {
  EVENT: 'EVENT',
  SERVER_EVENT: 'SERVER_EVENT',
  CHAT_STATUS: 'CHAT_STATUS',
  INTERNAL_ERROR: 'INTERNAL_ERROR',
  TEMPLATE: 'TEMPLATE',
  CONVERSATION_MESSAGE: 'CONVERSATION_MESSAGE',
  TYPING_CONVERSATION: 'TYPING_CONVERSATION',
  STOPPED_TYPING_CONVERSATION: 'STOPPED_TYPING_CONVERSATION',
  INITIATE_CONVERSATION: 'INITIATE_CONVERSATION',
  LIVE_CHAT: 'LIVE_CHAT',
  TECH_REPLY: 'TECH_REPLY',
  REQ_REPLY: 'REQ_REPLY',
  SESSION_CLOSED: 'SESSION_CLOSED',
  AGENT_EVENT: 'AGENT_EVENT',
  CLIENT_EVENT: 'CLIENT_EVENT',
  SESSION_CONNECTED: 'SESSION_CONNECTED',
  TECH_SCREENSHOT_REQUESTED: 'TECH_SCREENSHOT_REQUESTED',
  ASSET_OFFLINE: 'ASSET_OFFLINE',
  ASSET_ONLINE: 'ASSET_ONLINE',
  REQUESTER_NOT_ACCEPTED: 'REQUESTER_NOT_ACCEPTED',
  REQ_REJECTED_SCREENSHOT_REQUEST: 'REQ_REJECTED_SCREENSHOT_REQUEST',
  SCREENSHOT_TAKEN: 'SCREENSHOT_TAKEN',
  REMOTE_SESSION_STARTED: 'REMOTE_SESSION_STARTED',
  REMOTE_SESSION_ENDED: 'REMOTE_SESSION_ENDED',
  UPDATE_CONVERSATION: 'UPDATE_CONVERSATION'
};

const EVENT_MESSAGE_MAP = {
  TECH_SCREENSHOT_REQUESTED: 'msp.chat.event.screenshot.request',
  SESSION_CLOSED: 'msp.chat.event.session.closed',
  SESSION_CONNECTED: 'msp.chat.event.session.connected',
  ASSET_OFFLINE: 'msp.chat.event.asset.offline',
  ASSET_ONLINE: 'msp.chat.event.asset.online',
  SCREENSHOT_TAKEN: 'msp.chat.event.screenshot.captured',
  REQUESTER_NOT_ACCEPTED: 'msp.chat.event.requester.notaceepted',
  REMOTE_SESSION_STARTED: 'reports.pdf.prefix.remoteSessionStarted',
  REMOTE_SESSION_ENDED: 'reports.pdf.prefix.remoteSessionEnded',
  REQ_REJECTED_SCREENSHOT_REQUEST: 'msp.chat.event.screenshot.rejected'
};

const WAILS_EVENT = {
  MINIZE_WINDOW: 'MINIZE_WINDOW',
  NEW_MESSAGE: 'NEW_MESSAGE',
  INITIATE_PROMPT: 'INITIATE_PROMPT',
  CLOSE_WINDOW: 'CLOSE_WINDOW',
  TAKE_SCREENSHOT: 'TAKE_SCREENSHOT',
  CLOSE_PROMPT: 'CLOSE_PROMPT',
  PROMPT_RESPONSE: 'PROMPT_RESPONSE',
  LOGGING: 'LOGGING',
  KILL_WINDOW: 'KILL_WINDOW',
  SHOW_CHAT_PAGE: 'SHOW_CHAT_PAGE'
};

const NON_STORING_EVENTS = {
  WEB: [
    EVENT.STOPPED_TYPING_CONVERSATION,
    EVENT.TYPING_CONVERSATION,
    EVENT.UPDATE_CONVERSATION
  ],
  AGENT: [
    EVENT.REQUESTER_NOT_ACCEPTED,
    EVENT.REQ_REJECTED_SCREENSHOT_REQUEST,
    EVENT.ASSET_OFFLINE,
    EVENT.ASSET_ONLINE
  ]
};

const getIconName = (classId) => {
  return ASSETS_LIST_NUM[classId];
};

const MAX_CHARACTER = 4096;
const EDITOR_CONFIG = {
  app: 'SuperOps',
  docId: 'mydoc',
  username: 'Superops.ai',
  key:
    'jUA1yC3C4D2E2G2B2E1qYFa1UQRFQIVc2MSMd1IWPNb1IFd1yD2I2D1C2C7E2C1C5G1F1==',
  heightMin: 20,
  heightMax: 120,
  charCounterCount: true,
  charCounterMax: MAX_CHARACTER,
  imageUpload: false,
  imagePaste: false,
  imagePasteProcess: false,
  pasteDeniedTags: ['img'],
  imageDefaultDisplay: 'inline',
  toolbarInline: true,
  pluginsEnabled: ['charCounter']
};

const postMessageToWails = ({ eventName, data = null }) => {
  try {
    window.parent.postMessage(
      { eventName: eventName, data: data },
      window.frameParentOrigin
    );
  } catch (err) {
    console.log(
      'Error in posting message to wails parent:',
      window.frameParentOrigin
    );
  }
};

const openChatWindow = () => {
  postMessageToWails({
    eventName: WAILS_EVENT.NEW_MESSAGE
  });
};

const closeChatWindow = () => {
  postMessageToWails({
    eventName: WAILS_EVENT.CLOSE_WINDOW
  });
};
const killChatWindow = () => {
  postMessageToWails({
    eventName: WAILS_EVENT.KILL_WINDOW
  });
};
const closePromptWindow = (promptId) => {
  postMessageToWails({
    eventName: WAILS_EVENT.CLOSE_PROMPT,
    data: { id: promptId }
  });
};
const closeChatAndPromptWindow = (promptId, killWindow) => {
  if (killWindow) {
    killChatWindow();
    return;
  }
  postMessageToWails({
    eventName: WAILS_EVENT.CLOSE_PROMPT,
    data: { id: promptId }
  });
  postMessageToWails({
    eventName: WAILS_EVENT.CLOSE_WINDOW
  });
};

export {
  SOURCE,
  SUBPAGE,
  EVENT,
  WAILS_EVENT,
  NON_STORING_EVENTS,
  getIconName,
  openChatWindow,
  postMessageToWails,
  closeChatWindow,
  closePromptWindow,
  closeChatAndPromptWindow,
  EDITOR_CONFIG,
  MAX_CHARACTER,
  CHAT_TIMER_INSEC,
  EVENT_MESSAGE_MAP,
  IS_CHAT_ROUTE,
  IS_SYSTEMTRAY_ROUTE,
  killChatWindow
};
